<template>
	<div class="user_wrap">
		<div class="red_top_bg">
		    <div class="big_tit">{{$t('moneybag.myWallet')}}</div>
		</div>
		<div class="hellotitle">
			{{$t('c3.well')}} , {{data.mobile}}
		</div>
		<div  class="header_wrap">
			<div class="balance ">
				<p v-if="vip">
					<span class="vip0span" v-if="vip.no==0">{{vip.name}}</span>
					<span class="vip1span" v-if="vip.no==1">{{vip.name}}</span>
					<span class="vip2span" v-if="vip.no==2">{{vip.name}}</span>
					<span class="vip3span" v-if="vip.no==3">{{vip.name}}</span>
				</p>
				<p>
					Nilai Poin
				</p>
				<p>
					{{parseInt(1*data.money)}}
				</p>
				<div  class="detail-box">
					<p  class="title">{{$t('pro.creditScore')}}</p>
				    <p  class="money">{{data.credit}}</p>
				</div>
			</div>
			
		    
		</div>
	
		<div class="list" >
			<van-cell is-link @click="$router.push('/set')">
			  <template #title>
				<van-icon name="setting-o" size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">Pengaturan</span>
			  </template>
			</van-cell>
			<van-cell is-link @click="$router.push('/funds')">
			  <template #title>
				<van-icon name="debit-pay"  size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">Riwayat Transaksi</span>
			  </template>
			</van-cell>
			<van-cell is-link @click="$router.push('/notice')">
			  <template #title>
				<van-icon name="smile-comment-o" size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">Pesan</span>
			  </template>
			</van-cell>
			
			<!-- <van-cell is-link @click="$router.push('/invest')">
			  <template #title>
				<van-icon name="peer-pay" size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">{{$t('moneybag.recharge')}}</span>
			  </template>
			</van-cell> -->
			<van-cell is-link @click="$router.push('/cash')">
			  <template #title>
				<van-icon name="share-o" size="20" style="padding-right: 10px;"/>
				<span class="custom-title">{{$t('user.withdraw')}}</span>
			  </template>
			</van-cell>
			
			<van-cell is-link @click="$router.push('/withdrawRecord')">
			  <template #title>
				<van-icon name="certificate" size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">{{$t('user.withdrawalRecord')}}</span>
			  </template>
			</van-cell>
			<van-cell is-link @click="kefu_to" >
			  <template #title>
				<van-icon name="service" size="20" style="padding-right: 10px;"/>
			    <span class="custom-title">{{$t('webindex.custserver')}}</span>
			  </template>
			</van-cell>
			<!-- <div style="margin-top:0px;">	
				<div class="history_coupon flex_center basic_btn" @click="logout">
					<span>{{$t('safe.signOut')}}</span>
				</div>
			</div> -->
		</div>
		<div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
			<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
			<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
			<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
		</div>
		<div class="footerdesc">
			<div class="version">
				Expedia 2025.46.1 (252432001)
			</div>
			<div class="copyright">
			 © Hak Cipta 2012-2025 Expedia Group Semua hak cipta dilindungi undang-undang.
			</div>
		</div>
		<van-popup
		v-model="show"
		round 
		:style="{ 'line-height': '30px',
			'width': '70%',
			'padding': '15px',
			'font-weight': 'bold'}"
		>{{msg}}</van-popup>
	<!-- 	<div
		    v-if="msg_show"
		    class="kefu"
		    :class="show_kefu ? '' : 'kefu_hide'"
		    @click="kefu_to"
		>
		    <img class="kefu_img" src="../images/shop2/kefu.png" />
		</div> -->
	</div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import {
		Icon,
		Cell, 
		CellGroup ,
		Popup,
	} from "vant";
	
	Vue.use(Cell).use(CellGroup).use(Icon).use(Popup);
	import Clipboard from "v-clipboard";
	Vue.use(Clipboard);
	export default {
		name: "user",
		components: {
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				data: {},
				show_kefu: false,
				msg_show: true,
				vip:null,
				acc:null,
				msg:null,
				show:false,
				app:null,
				eye:1
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
			var that = this;
			document.body.addEventListener(
			    "scroll",
			    function() {
			        if (!that.show_kefu) {
			            return;
			        }
			        that.show_kefu = false;
			    },
			    false
			);
			document.addEventListener(
			    "click",
			    function(ev) {
			        if (ev.target.className != "kefu_img") {
			            that.show_kefu = false;
			        }
			    },
			    false
			);
		},
		methods: {
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if(data && data.length>0){
						this.msg = data[0].content;
						this.show= true;
						setTimeout(()=>{
						  Fetch('/user/notice_view', {
						  	id: data[0].id
						  }).then(res => {
						  })
						},2000);
					}
				});
			},
			kefu_to() {
				var link = this.app.kefu_link ;
				window.location.href = link;
			  //   if (this.show_kefu) {
					// // var link = this.app.kefu_link + '&uid='+this.acc.uid+ '&name='+this.acc.mobile;
					
			  //       // this.$router.push("/kefu");
			  //   }
			  //   this.show_kefu = !this.show_kefu;
			},
			downapp() {
			    top.location.href='/app.apk';
			},
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
				Fetch('/user/info').then((r) => {
					this.data = r.data;
					this.acc = r.data;
					if(r.data.vip){
						this.vip = r.data.vip;
					}
				});
				setTimeout(()=>{
				  this.sync()
				},2000)
			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		max-width: 100%;
	}
	.top_header {
		position: relative;
		width: 100%;
		height: 130px;
		background-size: 100% 100%;
		background: #0063d2;
		margin-top: -5px;
		.set_go{
			width: 38px;
			height: 38px;
			position: absolute;
			top: 11px;
		}
		
		.set_go {
			right: 14px;
			background: url(../images/user/sign.png) no-repeat center center;
			background-size: 100% 100%;
		}
		.user_detail {
			width: 100%;
			padding: 15px 15px 0 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0.3);
				img {
					width: 100%;
					height: 100%;
				}
			}
			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				color: #FFFFFF;
				.user_all {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.user_nickname {
						line-height: 1.6em;
						font-size: 1.2em;
						margin-left: 1em;
					}
				}
			}
		}
		.user_vip{
			color: #FFFFFF;
			font-weight: bold;
			font-size: 16px;
			margin: 10px 20px 20px 20px;
		}
		.user_balance{
			text-align: center;
			div{
				margin: 10px 0;
			}
			div:nth-child(1){
				font-size: 14px;
				color: #d3d5d6;
			}
			div:nth-child(2){
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}
		.user_money{
			justify-content: space-between;
			text-align: center;
			p{
				margin: 10px 0;
			}
			div{
				width: 100%;
			}
			p:nth-child(2){
				font-size: 14px;
				color: #d3d5d6;
			}
			p:nth-child(1){
				font-size: 18px;
				font-weight: 700;
				color: #FFFFFF;
			}
		}
	}
	.kong{
		width: 100%;
		height: 35px;
	}
	.history_coupon{
		margin: 30px auto 0 auto;
		border-radius:5px;
		text-align: center;
		span{
			font-size: 14px;
			height: 20px;
			line-height: 20px;
			position: relative;
			&::after{
				content: '';
				position: absolute;
				top: 3px;
				right: -25px;
				width: 12px;
				height: 13px;
				background: url(../images/user/more.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	.user_yw{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		position: relative;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 15px 0;
		position: relative;
		div{
			width: 50%;
		}
		p{
			margin-top: 8px;
		}
		img {
			height: 50px;
		}
	}
	// .money{
	// 	display: flex;
	// 	justify-content: space-between;
	// 	width: 96%;
	// 	background: #FFFFFF;
	// 	border-radius: 5px;
	// 	margin-top: -73px;
	// 	margin-left: 2%;
	// 	padding: 15px;
	// 	div:nth-child(1){
	// 		width: 40%;
	// 		text-align: left;
	// 		p:nth-child(1){
	// 			color: #999;
	// 			margin-bottom: 10px;
	// 		}
	// 		p:nth-child(2){
	// 			font-size: 14px;
	// 			font-weight: bold;
	// 		}
	// 	}
	// 	div:nth-child(2){
	// 		width: 60%;
	// 		text-align: right;
	// 		margin-top: 12px;
	// 		span{
	// 			padding: 5px 10px;
	// 			border-radius: 5px;
	// 			margin: 0 5px;
	// 		}
	// 		span:nth-child(1){
	// 			color: #FFFFFF;
	// 			background: #3775f4;
	// 		}
	// 		span:nth-child(2){
	// 			color: #3775f4;
	// 			background: #e9f0fb;
	// 		}
	// 	}
	// }
	.list{
		width: 100%;
		padding: 10px;
		background-color: #FFF;
		border-radius: 3%;
		img{
			vertical-align: middle;
			height: 30px;
			margin-right: 10px;
		}
	}
	.main_quantity{
	    width: 100%;
	    overflow: hidden;
	    border-radius: 10px;
	    padding: 15px;
	    box-sizing: border-box;
		.title{
		    align-items: flex-end;
		    font-size: 16px;
		    color: #FFFFFF;
		    font-weight: 700;
		}
		.word{
		    align-items: flex-end;
		    margin-bottom: 10px;
		}
		.des{
		    font-size: 12px;
		    color: #FFFFFF;
		    line-height: 19px;
			width: 90%;
		}
		>div:nth-child(2){
		    width: 135px;
		    height: 168px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	.flex-one {
	    flex: 1;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.ft28 {
	    font-size: 14px;
	}
	.ml10 {
	    margin-left: 5px;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft53 {
	    font-size: 25px;
	}
	.c_26a763 {
	    color: #FFFFFF;
	}
	.flex {
	    display: flex;
	}
	.user_invite{
	    width: 90%;
	    // background: url(../images/user/backimg.jpg);
	    background-size: 100%;
	    border-radius: 10px;
	    margin: 3% 5%;
	    padding: 5px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    color: #fff;
		margin-top: 30px;
		.invite_text{
		    width: 64%;
			display: block;
			p{
				font-size:16px;
			}
		}
		span{
			color: rgba(255, 255, 255, 0.6);
			font-size: 12px;
			line-height: 1.8em;
		}
		>div:last-child {
		    width: 30%;
		    height: 31px;
		    background-color: #ffcd00;
		    border-radius: 26px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 14px;
		}
	}
	.user_money{
		display: block;
	    width: 90%;
	    margin-left: 5%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    position: absolute;
	    bottom: -40px;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
			>div:first-child {
			    // display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
	}
	/deep/ .van-cell {
		padding: 10px 8px;
		border: 1px solid #999;
		margin-bottom: 10px;
		border-radius: 5px;
	}
	.but2 {
	    background-color: #232f3e;
	    color: #ffcd00;
	}
	.rightset {
	    position: absolute;
	    right: 10px;
	    top: 10px;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
		div {
		    margin-left: 10px
		}
		div img {
		    width: 20px!important
		}
	}
	.custom-title{
		font-size: 12px;
		font-weight: bold;
	}
	.jinsehng{
	    display: flex;
	    align-items: center;
	    padding-left: 18px;
	    height: 61px;
	    background: #0064d3;
		img{
			width: 45px; height: 46px;
		}
		a{
			font-size: 22px;
			font-weight: 600;
			color: #fff;
			text-decoration: none;
		}
	}
	
	.header_wrap{
	    margin: 12px 12px 0;
	    padding: 5px 11px 0px;
	    background: #fff;
	    border: 1px solid #CCC;
	    border-radius: 9px;
	    position: relative;
	    z-index: 1;
		margin-top: 0;
		.flexCenter {
		    display: flex;
		    align-items: center;
		    justify-content: center;
		}
		.account_wrap{
		    position: relative;
		    display: flex;
		    align-items: center;
		    padding-left: 7px;
		}
		.user_icon{
		    width: 60px;
		    height: 60px;
		}
		.rightBox {
		    flex: 1;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    padding-right: 18px;
		}
		.account_id{
		    display: flex;
		    flex-direction: column;
		    justify-content: center;
		    margin-left: 15px;
			.userName{
			    font-size: 16px;
			    font-weight: 600;
			    color: #000;
			}
			.level {
			    margin-top: 6px;
				img {
				    width: 50px;
				    height: 38px;
				    margin-right: 6px;
				    margin-left: -20px;
				}
				 span{
				    font-size: 12px;
				    font-weight: 500;
				    color: #000;
				    margin-left: -20px;
				}
			}
		}
		.balance_wrap{
		    margin-top: 16px;
		    height: 68px;
		    background: #f1f8fe;
		    border-radius: 9px;
		    display: flex;
		    justify-content: space-between;
			.detail-box{
			    display: flex;
			    flex-direction: column;
			    justify-content: center;
			    flex: 1;
				line-height: 20px;
				.money {
				    font-size: 12px;
				    font-weight: 400;
				    color: #333;
				    text-align: center;
				}
				.title {
				    font-size: 12px;
				    font-weight: 400;
				    color: #333;
				    text-align: center;
				    margin-top: 4px;
				}
			}
		}
	}
	.hellotitle{
		line-height: 30px;
		font-size: 20px;
		font-weight: bold;
		color: #000;
		margin: 10px 20px 0 20px;
	}
	.balance{
		padding: 10px 0px;
		text-align: center;
		margin: 10px;
		margin-bottom: 0;
		padding-bottom: 0;
		p:nth-child(1){
			font-size: 14px;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #000;
			font-size: 14px;
			margin-bottom: 15px;
		}
		p:nth-child(3){
			color: #000;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 0;
		}
		.detail-box{
			margin-top: 25px;
			color: #000;
			font-size: 14px;
		}
	}
</style>
